import { useQuery } from 'react-query';
import { network } from 'services/network';

import { QueryKeys } from 'api/queryKeys';

const queryFn = (params: Omit<QueryParams, 'runQsra'>): Promise<QueryFnResponse> => {
    return network.post('api/bo/getDistributionGraphData', params).then((response) => {
        return response.data;
    });
};

export const useQueryGetDistributionGraph = (params: QueryParams) => {
    const { runQsra, ...payload } = params;
    return useQuery<QueryResponse, QueryError, QueryResponse | undefined, [QueryKeys, unknown]>({
        queryKey: ['getDistributionGraph', params],
        queryFn: () => queryFn(payload),
        enabled: Boolean(params.runQsra) && Boolean(params.taskVersionHashCode) && Boolean(params.metaDataId),
        select: (response) => {
            const periods = {
                MONTH: 'month',
                WEEK: 'week',
                DAY: 'day',
                YEAR: 'year',
            };

            return response ? { ...response, period: periods[response.period] } : undefined;
        },
    });
};

interface QueryParams {
    metaDataId: number;
    numOfIterations: number;
    riskIds: number[];
    taskVersionHashCode: string | null;
    runQsra: number | null;
    period: string;
}

interface QueryResponse {
    lineSeries: GraphLine;
    barSeries: GraphLine;
    info: IToolTip;
    period: string;
}

interface QueryFnResponse {
    lineSeries: GraphLine;
    barSeries: GraphLine;
    info: IToolTip;
    period: 'MONTH' | 'WEEK' | 'DAY';
}

interface Data {
    text: number;
    label: number;
    value: number;
}

interface GraphLine {
    title: string | null;
    seriesname: null;
    data: Data[];
}
